// extracted by mini-css-extract-plugin
export default {"wrapper":"ProvisionPage_wrapper__bPB6y"};